/* global google */
const lotMap = document.getElementsByClassName('wc-ezpark-lot-map')[0];

const markers = [];

function initMap() {
  const map = new google.maps.Map(lotMap, {
    zoom: 15,
  });
  const lat = parseFloat(lotMap.dataset.lat);
  const lng = parseFloat(lotMap.dataset.lng);
  const marker = new google.maps.Marker({
    position: { lat, lng },
    map,
  });

  // Pan to marker on click
  google.maps.event.addListener(marker, 'click', () => {
    map.panTo({ lat, lng });
  });

  markers.push(marker);
  map.panTo({ lat, lng });
}

// eslint-disable-next-line no-use-before-define
const $inits = $inits || [];
$inits.push(
  () => {
    initMap();
  },
);
